import webserviceWrapper from "../_helpers/webserviceWrapper";

export const loginService={
    //getAll,
    Login,
    RegisterUser,
    GetData,
    SendResetEmail,
    updatePassword,
    CheckIfLinkValid,
    GetClassList,
    GetCountryList,
    CheckIfPasswordChangeLinkValid,
    GetClassificationList,
}

// function getAll() {
//     const requestOptions = {
//       method: "GET",
//       headers: authHeader(),
//     };
// }

/* <summary>
date: 30-05-2022
Name: VD
description: This is used to get the user login info to check if the user can access or not
<summary>*/ 
function Login(userName,password,surname,slectedGrade){
    return webserviceWrapper.post(
        `Login/GetLoginInfo`,
        {userName,password,surname,slectedGrade}
    );
}

/* <summary>
date: 16-06-2022
Name: VD
description: This is used to saves the data of the new registered user
<summary>*/ 
function RegisterUser(registerModel){
    return webserviceWrapper.post(
        `Login/RegisterUser`,
        registerModel
    );
}

function GetData(){
    return webserviceWrapper.get(
        `Login/GetData`
    );
}

function SendResetEmail(emailToReset){
    return webserviceWrapper.post(
        `Login/SendResetEmail`,
        {emailToReset}
    );
}

function updatePassword(guid,password){
    return webserviceWrapper.post(
      `Login/updatePassword`,
      {guid,password} ,
      60000
    );
}

function CheckIfLinkValid(guid){
    return webserviceWrapper.post(
      `Login/CheckIfLinkValid`,
      {guid} ,
      60000
    );
}

function GetClassList(){
    return webserviceWrapper.get(
        `Login/GetClassList`
    );
}

function GetCountryList(){
    return webserviceWrapper.get(
        `Login/GetCountryList`
    );
}

function CheckIfPasswordChangeLinkValid(guid){
    return webserviceWrapper.post(
      `Login/CheckIfPasswordChangeLinkValid`,
      {guid} ,
      60000
    );
}

function GetClassificationList(){
    return webserviceWrapper.get(
        `Login/GetClassificationList`
    );
}